import { FC } from 'react'

type BurgerIconProps = {}

const BurgerIcon: FC<BurgerIconProps> = ({}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 6.5H19.5M4.5 12H19.5M4.5 17.5H19.5"
        stroke="#2B2F33"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BurgerIcon
